module.exports = __webpack_public_path__ + "img/facebook.34b594a4.svg";